import FactoringOffers from './FactoringOffers';
export default FactoringOffers;
